<div class="ssbWrapper">
    <img src="./images/SBB_CFF_FFS_logo.svg" alt="SBB_CFF_FFS_logo">
    <h2>{{ appCopy.panelHeader['sbbDiscountTitle'+selectedLanguage] }}</h2>
    <p>{{ appCopy.panelHeader['sbbDiscountDescription'+selectedLanguage].replace('%s', appAirportCopy[airportCode]["airportName" + this.selectedLanguage]) }}</p>
    <div class="checkbox checkbox--default margin-bottom-24">
        <input type="checkbox" name="publicTransport" id="publicTransport"
            (click)="publicTransportSubsidy($event)"
            [ngModel]='isSbbSubsidyApplied'>
            <!-- sbbDiscountCheckLabel -->
        <label for="publicTransport">{{ appCopy.panelHeader['sbbDiscountCheckLabel'+selectedLanguage].replace('%s', appAirportCopy[airportCode]["airportName" + this.selectedLanguage]) }}</label>
    </div>
</div>
